export class ProposalCoverageScheduleDO {
    public id: Number = null;
    public getid(): Number {
        return this.id;
    }
    public setid(value: Number) {
        this.id = value;
    }

    public proposalYear: Number = null;
    public getproposalYear(): Number {
        return this.proposalYear;
    }
    public setproposalYear(value: Number) {
        this.proposalYear = value;
    }

    public sumInsured: Number = null;
    public getsumInsured(): Number {
        return this.sumInsured;
    }
    public setsumInsured(value: Number) {
        this.sumInsured = value;
    }

    public baseAnnualPremium: Number = null;
    public getbaseAnnualPremium(): Number {
        return this.baseAnnualPremium;
    }
    public setbaseAnnualPremium(value: Number) {
        this.baseAnnualPremium = value;
    }

    public premiumRate: Number = null;
    public getpremiumRate(): Number {
        return this.premiumRate;
    }
    public setpremiumRate(value: Number) {
        this.premiumRate = value;
    }

    public productTypeCd: String = null;
    public getproductTypeCd(): String {
        return this.productTypeCd;
    }
    public setproductTypeCd(value: String) {
        this.productTypeCd = value;
    }

}